import { z } from 'zod';

// === Einzelne Schemas ===
export const processManagerAutomationLegalRequirementChangeSchema = z.object({
  idLegalRequirement: z.number(),
  idLegalRequirementState: z.number(),
});

export const processManagerAutomationEmailSchema = z.object({
  Subject: z.string().default(''),
  Body: z.string().default(''),
});

export const processManagerAutomationEmailToLegalClientSchema =
  processManagerAutomationEmailSchema.extend({
    idLegalClient: z.number(),
  });

export const processManagerAutomationEmailToExternalSchema =
  processManagerAutomationEmailSchema.extend({
    Receiver: z.string(),
  });

// === Hauptschema ===
export const processManagerAutomationSchema = z.object({
  idProcessManagerAutomation: z.number().default(-1),
  idProcessManager: z.number(),
  idProcessManagerAutomationType: z.number().default(1),
  Created_at: z.date().default(() => new Date(new Date().toISOString())),
  Updated_at: z.date().default(() => new Date(new Date().toISOString())),
  data: z
    .union([
      z.object({}), // leeres Objekt
      processManagerAutomationLegalRequirementChangeSchema,
      processManagerAutomationEmailToLegalClientSchema,
      processManagerAutomationEmailToExternalSchema,
    ])
    .default(() =>
      processManagerAutomationLegalRequirementChangeSchema.parse({})
    ),
});

// === Abgeleitete TypeScript-Typen ===
export type IProcessManagerAutomationLegalRequirementChange = z.infer<
  typeof processManagerAutomationLegalRequirementChangeSchema
>;

export type IProcessManagerAutomationEmail = z.infer<
  typeof processManagerAutomationEmailSchema
>;

export type IProcessManagerAutomationEmailToLegalClient = z.infer<
  typeof processManagerAutomationEmailToLegalClientSchema
>;

export type IProcessManagerAutomationEmailToExternal = z.infer<
  typeof processManagerAutomationEmailToExternalSchema
>;

export type IProcessManagerAutomation = z.infer<
  typeof processManagerAutomationSchema
>;
